export async function GetPostcodeLocation(postcode, key) {
    const result = await fetch('https://api.addressy.com/Geocoding/UK/Geocode/v2.10/json3.ws', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({Key: key, Location: postcode})
    });
    const data = await result.json();
    if (data.Items.length === 1 && typeof (data.Items[0].Error) != "undefined") {
        return {
            success: false,
            error: data.Items[0].Description
        };
    } else {
        // Check if there were any items found
        if (data.Items.length === 0)
            return {
                success: false,
                error: "Sorry, we couldn't find that postcode."
            };
        else {
            return {
                success: true,
                postcode: postcode,
                latitude: data.Items[0].Latitude,
                longitude: data.Items[0].Longitude
            }
        }
    }

}